(function () {
	function insertBankInfo() {
		const target = document.querySelector(".mt-cod-brand-mark");

		if (!target) return;
		if (document.querySelector(".custom-bank-transfer-info")) return;

		const bankInfo = document.createElement("div");

		bankInfo.className = "custom-bank-transfer-info";

		bankInfo.innerHTML = `
            <div class="bank-transfer-title">
              Or Online Bank Transfer
            </div>

            <div class="bank-transfer-description">
               Make your payment directly into our bank account and send a screenshot to our WhatsApp number 0332-3025767. Please use your Order ID as the payment reference.
            </div>

            <div class="bank-transfer-account">
                Meezan Bank Account Number: 01860112000673 ABBAS NAZIR
            </div>
             <div class="bank-transfer-account">
            EASYPAISA BANK Account Number: 03323025767 ABBAS NAZEER"
            </div>
        `;

		target.parentNode.insertBefore(bankInfo, target);
	}

	const style = document.createElement("style");

	style.textContent = `
        .custom-bank-transfer-info {
            width: 100%;
            box-sizing: border-box;
            text-align: center;
            color: #111;
            margin: 20px auto;
            padding: 0 15px;
            font-family: Arial, sans-serif;
        }

        .bank-transfer-title {
            font-size: 24px;
            font-weight: 700;
            line-height: 1.4;
            margin-bottom: 12px;
        }

        .bank-transfer-description {
            max-width: 750px;
            margin: 0 auto 18px;
            font-size: 17px;
            font-weight: 600;
            line-height: 1.6;
        }

        .bank-transfer-account {
            font-size: 21px;
            font-weight: 700;
            line-height: 1.5;
        }

        @media (max-width: 600px) {
            .bank-transfer-title {
                font-size: 20px;
            }

            .bank-transfer-description {
                font-size: 15px;
            }

            .bank-transfer-account {
                font-size: 18px;
            }
        }
    `;

	document.head.appendChild(style);

	insertBankInfo();

	// Trường hợp element được tạo/render sau
	const observer = new MutationObserver(insertBankInfo);

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
})();